import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { GlobalTroubleshootPanel } from "@/components/GlobalTroubleshootPanel";
import { AuthCallbackPage } from "@/pages/AuthCallbackPage";
import { ChangePasswordPage } from "@/pages/ChangePasswordPage";
import { MyAppsPage } from "@/pages/MyAppsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { SignInPage } from "@/pages/SignInPage";
import { TokensPage } from "@/pages/TokensPage";

export function App() {
  return (
    <>
    <GlobalTroubleshootPanel />
    <Routes>
      <Route path="/" element={<Navigate to="/myapps" replace />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/myapps" element={<MyAppsPage />} />
        <Route path="/myapps/profile" element={<ProfilePage />} />
        <Route
          path="/myapps/change-password"
          element={<ChangePasswordPage />}
        />
        <Route path="/myapps/tokens" element={<TokensPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </>
  );
}
